export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const MODAL_CLOSE_SEC = 2.5;
export const RES_PER_PAGE = 10;
export const KEY = '076444b7-b671-4ce8-85a2-a141ab854716';
